"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var TabContent = function TabContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      selectedIndex = _ref.selectedIndex,
      renderActiveOnly = _ref.renderActiveOnly;
  var classes = (0, _classnames.default)('TabContent', className);
  return _react.default.createElement("div", {
    className: classes
  }, (0, _map.default)(_react.Children).call(_react.Children, children, function (panel, i) {
    if (panel) {
      if (renderActiveOnly) {
        if (selectedIndex === i) {
          return (0, _react.cloneElement)(panel, {
            active: true,
            index: i
          });
        } else {
          return null;
        }
      } else {
        return (0, _react.cloneElement)(panel, {
          active: selectedIndex === i,
          index: i
        });
      }
    }
  }));
};

var _default = TabContent;
exports.default = _default;